export default __webpack_public_path__ + "static/media/preparacion.4d197bf6.svg";